import { colorValues, customCalendarModelValues } from "@ac-expo/api-types";
import { z } from "zod";
import { fileSchema } from "../../files";

export const UpsertCustomCalendarSchema = z.object({
  id: z.string().optional(),
  eventId: z.string().uuid(),
  model: z.enum(customCalendarModelValues),
  opacity: z.number().min(0).max(100),
  backgroundColor: z.enum(colorValues),
  fullDayColor: z.enum(colorValues),
  polyAnimationColor: z.enum(colorValues),
  backgroundPicture: fileSchema.nullable(),
});

export const defaultUpsertCustomCalendarValues = {
  id: undefined,
  eventId: "",
  model: "verticalDayHour" as const,
  opacity: 100,
  backgroundColor: "white" as const,
  fullDayColor: "orange" as const,
  polyAnimationColor: "gray" as const,
  backgroundPicture: null,
};

export type UpsertCustomCalendarForm = z.infer<
  typeof UpsertCustomCalendarSchema
>;

export const UpsertCustomCalendarTemplateSchema = z.object({
  templateName: z.string(),
  slot: z.number().min(0).max(4),
});

export const defaultUpsertCustomCalendarTemplateValues = {
  templateName: "",
  slot: 0,
} as const;

export type UpsertCustomCalendarTemplateForm = z.infer<
  typeof UpsertCustomCalendarTemplateSchema
>;

export type CustomCalendarTemplateForm = UpsertCustomCalendarForm &
  UpsertCustomCalendarTemplateForm;
